module.exports = __webpack_public_path__ + "fonts/gothambold-webfont-old.767cebb5.woff";